import React, { ReactNode } from 'react';

import { Button } from '@trqk/components';
import { locale } from '@trqk/utils';

import { PATHS } from '../../../constants';

import './auth-layout.css';

interface AuthLayoutProps {
    children: ReactNode;
}

export const AuthLayout = ({ children }: AuthLayoutProps): JSX.Element => (
        <div className="auth-layout h-screen w-screen bg-primary-500">
            <div className="fixed top-0 right-0 pt-6 pr-6">
                <a href={PATHS.CONTACT}>
                    <Button
                        autoWidth={true}
                        color="tertiary-dark-bg"
                        padding="sm"
                    >
                        <div className="mx-8">
                            {locale.enUS.AUTH_LAYOUT.BUTTONS.CANCEL}
                        </div>
                    </Button>
                </a>
            </div>
            {children}
        </div>
    );
